export default __webpack_public_path__ + "static/media/mercy-watchingover.ea7e66e5.mp3";